/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Step {
  label: string;
  isActive: boolean;
  isCompleted: boolean;
}

interface BreadCrumbProps {
  steps: Step[];
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ steps }) => {
  const { t } = useTranslation();
  return (
    <nav style={styles.breadcrumb}>
      <ul style={styles.breadcrumbList}>
        {steps.map((step, index) => (
          <li key={index} style={styles.breadcrumbItem}>
            <div style={styles.circleConnectorWrapper}>
              {/* Step Circle */}
              <div
                style={{
                  ...styles.circle,
                  backgroundColor: step.isCompleted ? '#23a6f5' : '#fff',
                  border:
                    step.isCompleted || step.isActive
                      ? '2px solid #23a6f5'
                      : '2px solid #C9C9C9',
                  color: step.isCompleted
                    ? '#fff'
                    : step.isActive
                      ? '#23a6f5'
                      : '#707070',
                }}
              >
                {step.isCompleted ? (
                  <span style={styles.checkMark}>✔</span>
                ) : (
                  <span style={styles.circleNumber}>{index + 1}</span>
                )}
              </div>

              {/* Line (Connector to next step) */}
              {index < steps.length - 1 && (
                <div
                  style={{
                    ...styles.connectorLine,
                    backgroundColor: step.isCompleted ? '#23a6f5' : '#C9C9C9',
                  }}
                />
              )}
            </div>

            {/* Step Label */}
            <div
              style={{
                ...styles.label,
                color: step.isActive
                  ? '#23a6f5'
                  : step.isCompleted
                    ? '#696969'
                    : '#696969',
              }}
            >
              {t(step.label)}
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
};

const circleDiameter = 44;

const styles: { [key: string]: React.CSSProperties } = {
  breadcrumb: {
    width: '100%',
    // backgroundColor: '#fff',
    padding: '25px 0 10px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  breadcrumbList: {
    listStyle: 'none',
    display: 'flex',
    margin: 0,
    padding: 0,
    width: '80%',
    justifyContent: 'space-between',
  },
  breadcrumbItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    flex: 1,
  },
  circleConnectorWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    justifyContent: 'center',
  },
  circle: {
    width: circleDiameter,
    height: circleDiameter,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    background: '#fff',
    zIndex: 2,
    position: 'relative',
    transition: 'border-color .2s, background .2s',
    boxSizing: 'border-box',
  },
  checkMark: {
    fontSize: 22,
    lineHeight: 1,
  },
  circleNumber: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1,
  },
  connectorLine: {
    position: 'absolute',
    top: '50%',
    left: `50%`,
    transform: 'translateY(-50%)',
    height: 2,
    width: '100%',
    zIndex: 1,
  },
  label: {
    marginTop: 10,
    fontSize: 13,
    textAlign: 'center',
    fontWeight: 500,
    fontFamily: 'OpenSans-bold'
  },
};

export default BreadCrumb;
